import React, { useState, useEffect, useRef } from 'react';
import SectionTitle from './SectionTitle';
import FormItemLabel from './FormItemLabel';
import Spacer from './Spacer';
import SubmitButton from './SubmitButton';
import RadioButtons from './RadioButtons';
import TutrialVideo from './TutrialVideo';

function BeforeQuestionnaire(props) {
    const { moveOnToTheNextStep } = props;

    const [formValues, setFormValues] = useState({
        gender: '',
        age: '',
        wheelchair: ''
    });

    const [isFormComplete, setIsFormComplete] = useState(false);
    const [currentTimestamp, setCurrentTimestamp] = useState('');
    const [isTutrialPlayed, setIsTutrialPlayed] = useState(false);

    const videoRef = useRef(null); // 動画の参照を作成

    useEffect(() => {
        const now = new Date();
        now.setHours(now.getHours() + 9);
        const formattedTimestamp = now.toISOString().slice(0, 19).replace('T', ' ');
        setCurrentTimestamp(formattedTimestamp);
    }, []);

    const handleChange = (name, value) => {
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    useEffect(() => {
        const allFilled = Object.values(formValues).every(value => value !== '');
        setIsFormComplete(allFilled);
    }, [formValues]);

    const handleSubmitButtonClick = () => {
        if (videoRef.current) {
            videoRef.current.pause(); // 動画を停止
        }
        moveOnToTheNextStep();
    };

    const handleTutrialPlayed = () => {
        setIsTutrialPlayed(true);
    };

    const [questionnaireStep, setQuestionnaireStep] = useState(0);

    const handleNextButtonClick = () => {
        if (isFormComplete) {
            setQuestionnaireStep(questionnaireStep + 1);
        } else {
            alert("全ての必須項目を入力してください。");
        }
    };

    return (
        <>
            <div className={`before-questionnaire questionnaire-form-window-container ${questionnaireStep === 0 ? "is-active" : ""}`}>
                <div className="questionnaire-form-window">
                    <SectionTitle label="あなたについてお聞きします" />
                    <div className="questionnaire-form">
                        <input name="回答日時" type="hidden" value={currentTimestamp} />
                        <div className="questionnaire-form-item">
                            <FormItemLabel text="性別" required />
                            <RadioButtons
                                required
                                name="gender"
                                options={["男性", "女性"]}
                                onChange={value => handleChange('gender', value)}
                            />
                        </div>
                        <div className="questionnaire-form-item">
                            <FormItemLabel text="年齢" required />
                            <RadioButtons
                                required
                                name="age"
                                options={["70才以上", "50-69才", "30-49才", "29才以下"]}
                                onChange={value => handleChange('age', value)}
                            />
                        </div>
                        <div className="questionnaire-form-item">
                            <FormItemLabel text="日常の歩行の困難度について" required />
                            <RadioButtons
                                required
                                name="wheelchair"
                                options={["特に支障なし", "杖や歩行補助器具を利用している", "車いすを利用している", "妊婦・ベビーカーを利用している", "その他"]}
                                onChange={value => handleChange('wheelchair', value)}
                            />
                        </div>
                    </div>
                    <Spacer sizePC="24" />
                    {!isFormComplete ?
                        <>
                            <div className="form-info">
                                <p>すべての項目を入力してください</p>
                            </div>
                            <Spacer sizePC="48" />
                        </>
                    : ""}
                    <SubmitButton label="次へ進む" onClick={handleNextButtonClick} disabled={!isFormComplete} />
                </div>
            </div>
            <div className={`before-questionnaire questionnaire-form-window-container ${questionnaireStep === 1 ? "is-active" : ""}`}>
                <div className="questionnaire-form-window">
                    <div className="questionnaire-info">
                        <h3 className="questionnaire-info__title">状況説明とアンケートの回答方法について</h3>
                        <div className="questionnaire-info__content">
                            <div className="description-image sp-none">
                                <img src={`${process.env.PUBLIC_URL}/images/tutrial-play-description.webp`} alt="動画左下に再生ボタンがある。" />
                            </div>
                            <p>
                                状況説明とアンケートの回答方法を動画で説明します。<br />
                                再生ボタン▶をクリックして、動画をご覧ください
                            </p>
                            <div className="pc-none">
                                <Spacer sizePC="12" />
                            </div>
                            <div className="description-image pc-none">
                                <img src={`${process.env.PUBLIC_URL}/images/tutrial-play-description.webp`} alt="動画左下に再生ボタンがある。" />
                            </div>
                            <Spacer sizePC="24" />
                            <TutrialVideo ref={videoRef} videoSrc="./videos/tutrial.mp4" onVideoPlayed={handleTutrialPlayed} />
                        </div>
                    </div>
                    {!isTutrialPlayed ?
                        <>
                            <Spacer sizePC="24" />
                            <div className="form-info">
                                <p>動画で回答方法を確認してください。（動画を最後まで視聴すると、次に進めます）</p>
                            </div>
                        </>
                    : ""}
                    <Spacer sizePC="32" />
                    <SubmitButton label="避難を開始する" onClick={handleSubmitButtonClick} disabled={!isTutrialPlayed} />
                </div>
            </div>
        </>
    );
}

export default BeforeQuestionnaire;
